import React, { useState, useEffect } from "react";
import Modal from 'react-modal';
import styles from '../../styles/UserProfile.module.css';
import { useSession, signOut } from 'next-auth/react';
import { useRouter } from 'next/navigation';
import { useTheme } from "next-themes";
import $ from 'jquery'
import ApiUrl from '../../url.json';
Modal.setAppElement('#__next');
import StdManageWidget from "../widgets/StdManageWidget";

const UserProfileModal = ({ isOpen, onRequestClose }) => {

  //* code for theme */
  const { theme, setTheme } = useTheme();
  useEffect(() => {
    const getSystemTheme = async () => { };
    getSystemTheme();
  }, [setTheme, theme]);
  //* code for theme */

  const { data: session } = useSession();
  const [showWidget, setShowWidget] = useState(false);
  const [showDetails, setShowDetails] = useState({ "userName": "Empty" });
  const router = useRouter();
  const [open1, setOpen1] = useState(false)
  const [refreshGenericTable, setRefreshGenericTable] = useState(false);
  const triggerGenericRefresh = () => {
    setRefreshGenericTable((prev) => !prev);
  };
  useEffect(() => {
    fetchUserDetails();
  }, [])

  const handleSignOut = async () => {
    localStorage.clear();
    document.cookie = 'jwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    await signOut({ redirect: false });
    router.push('/');
  };

  const fetchUserDetails = () => {
    let userId = localStorage['_id'];
    let userRole = localStorage['roles'];

    // Check if user is a candidate
    if (userRole === 'Candidate') {
      // Use candidate-specific API
      $.ajax({
        type: "GET",
        url: ApiUrl.newUrl + "/api/candidate/profile?candidateId=" + userId,
        dataType: "json",
        async: false,
        headers: { jwt: localStorage.getItem("jwt") },
        success: function (result) {
          if (result && result.success) {
            setShowDetails(result.data[0]);
            console.log('Candidate details fetched successfully');
          }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
          console.error("Error fetching candidate details:", textStatus, errorThrown);
        }
      });
    } else {
      // Use regular user API
      $.ajax({
        type: "GET",
        url:
          ApiUrl.newUrl +
          "/api/dbjsonschema/getPackageInfo/Users" +
          "/" +
          userId,
        dataType: "json",
        async: false,
        headers: { jwt: localStorage.getItem("jwt") },
        success: function (result) {
          if (result) {
            setShowDetails(result.data[0]);
            console.log('User details fetched successfully');
          }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
          console.error("Error fetching UserDetails:", textStatus, errorThrown);
        }
      });
    }
  }

  // console.log(showDetails._id);


  const handleEditProfile = () => {

    if (showWidget) {
      setShowWidget(false);

    }
    else {
      setShowWidget(true);
      setOpen1(true);
    }

  };

  // {open1 && <StdManageWidget open1={open1} setOpen1={setOpen1} 
  // setShowWidget={setShowWidget} mode="edit" currentSchemaName="Users" 
  // currentItemID={showDetails.userName ? '' : localStorage['_id']} currentTitleName="User" />}


  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        contentLabel="User Profile Modal"
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
          }
        }}
        className={styles.userProfileModalPopup}
      >
        <div className={styles.modalHeader}>
          {/* <h2 className={styles.modalTitle}><b>User Profile</b></h2> */}
          <button className={styles.onRequestClose} onClick={onRequestClose}>
            <span>&times;</span>
          </button>
        </div>

        {session ? (
          <div className={styles.modalContent}>
            <p className={styles.bottomSpace}><strong className={styles.modelLabelTitle}>Name:</strong> <span className={styles.modelLabelValue}>{localStorage.name}</span></p>
            <p className={styles.bottomSpace}><strong className={styles.modelLabelTitle}>Email:</strong> <span className={styles.modelLabelValue}>{localStorage.userId}</span></p>
            <p className={styles.bottomSpace}><strong className={styles.modelLabelTitle}>Company:</strong> <span className={styles.modelLabelValue}>{localStorage.company}</span></p>
            <p className={styles.bottomSpace}><strong className={styles.modelLabelTitle}>Role:</strong> <span className={styles.modelLabelValue}>{localStorage.roles}</span></p>

            {/* <p className={styles.bottomSpace}><strong className={styles.modelLabelTitle}>Name:</strong> <span className={styles.modelLabelValue}>{session.user.name}</span></p>
          <p className={styles.bottomSpace}><strong className={styles.modelLabelTitle}>Email:</strong> <span className={styles.modelLabelValue}>{session.user.email}</span></p>
          <p className={styles.bottomSpace}><strong className={styles.modelLabelTitle}>Company:</strong> <span className={styles.modelLabelValue}>{localStorage.companyName}</span></p>
          <p className={styles.bottomSpace}><strong className={styles.modelLabelTitle}>Roles:</strong> <span className={styles.modelLabelValue}>{localStorage.roles}</span></p>
           */}
            <div className={styles.buttonGroup}
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
              {/* {localStorage.roles!="Internal User"&& 
                 <button className={styles.editProfileBtn} onClick={handleEditProfile}>
                  Edit Profile
                </button>
              }              */}
              <button className={styles.sign_out_btn} onClick={handleSignOut}>
                Sign Out
              </button>
            </div>
          </div>
        ) : (
          <p>Please log in</p>
        )}
      </Modal>
      {/* {open1 && <StdManageWidget open1={open1} setShowWidget={setOpen1} */}
      {/* mode="Edit" currentSchemaName="Users"
        currentItemID={showDetails['_id']} currentTitleName="User" userEditProfile="userEditProfile" />} */}

      {showWidget && <StdManageWidget open1={showWidget} setShowWidget={setShowWidget}
        mode="Edit" currentSchemaName="Users"
        currentItemID={showDetails['_id']} currentTitleName="User" userEditProfile="userEditProfile" onRefresh={triggerGenericRefresh} />}

    </>
  );

};

export default UserProfileModal;
